import { render } from "./GlowButtonEffect.vue?vue&type=template&id=fde1841c&scoped=true"
import script from "./GlowButtonEffect.vue?vue&type=script&lang=js"
export * from "./GlowButtonEffect.vue?vue&type=script&lang=js"

import "./GlowButtonEffect.vue?vue&type=style&index=0&id=fde1841c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fde1841c"]])

export default __exports__